import React from "react";
import Banner from "../components/about-him/banner";
import About from "../components/about-him/about";
import HimFooter from "../components/about-him/footer";

function AboutHim() {
  return (
    <>
      <Banner />
      <About />
      <HimFooter />
    </>
  );
}

export default AboutHim;
